const THEME = {
  LIGHT: "light",
  DARK: "dark",
  CUSTOM: "custom"
};
export {
  THEME
};
